/**
 * <strong>Purpose:</strong> <br>
 * Adds aria-labelledBy attribute to the widget.
 * <br><br>
 * <strong>Contract:</strong> <br>
 * The widget should have buttonNode, focusNode, textNode, textLine, inlineTextNode and lastTextLineNode. <br>
 * This mixin is dependent upon: <br>
 * {@link module: MW/toolstrip/form/mixins/property/DropDownButtonTextMixin} <br>
 *
 * @module MW/toolstrip/form/mixins/property/DropDownLikeButtonA11yMixin
 *
 * @copyright Copyright 2019 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "MW/toolstrip/form/mixins/property/DropDownButtonTextMixin"
], function (declare, DropDownButtonTextMixin) {

    var DropDownLikeButtonA11yMixin = declare(null, {

        _setTextAttr: function () {
            this.inherited(arguments);

            // Remove any aria-labelledby attribute that is set before (from the mw-form code) on the buttonNode.
            this.buttonNode.removeAttribute("aria-labelledby");

            var id = this.get("id");
            if (id) {
                // For DropDownButton, SplitButton and ToggleSplitButton, textLine node contains the entire text.
                // This is true even for multiline texts where textLine nodes have the entire text and visually the
                // text is shown in multiple lines using inlineTextLine and lastTextLine nodes.
                var textLineId = this.get("id") + "_textLineLabel";
                this.textLine.setAttribute("id", textLineId);

                // Set aria-labelledby attribute to point to the id of the textLine node
                this.focusNode.setAttribute("aria-labelledby", textLineId);

                if (this.buttonNode.getAttribute("role") === "button") { // SplitButton, ToggleSplitButton or their
                                                                         // corresponding QAB components

                    // Ideally we could have set the aria-labelledby attribute of the buttonNode to the id of the
                    // textLine node. However, when we use the same id as the aria-labelledby attribute value for
                    // two nodes, then one of them will show up as "unlabelled" in the screen reader elements
                    // dialog. Hence, we set the aria-label on the buttonNode instead, to get around that issue.
                    var buttonNodeLabel = this.textLine.getAttribute("data-text-content");
                    this.buttonNode.setAttribute("aria-label", buttonNodeLabel);
                }

            }
        }
    });

    DropDownLikeButtonA11yMixin._dependencies = [
        {mixin: DropDownButtonTextMixin, orderDependent: true}
    ];
    return DropDownLikeButtonA11yMixin;
});